import {
  defaultCallableTriggerIconPath,
  scriptStepTypes,
} from '@xmatters/common/constants/scriptSteps';
import { EVERBRIDGE_LOGO_PATH } from '@xmatters/common/constants/image';
import AutomationIcon from 'resources/svg/incident-automation.svg';
import IncidentInitiation from 'resources/svg/incident-initiation.svg';
import NotifyToEngage from 'resources/svg/notify-to-engage-small.svg';
import SeverityChange from 'resources/svg/severity-change-small.svg';
import IconResponded from 'resources/svg/icon-responded.svg';
import { IncidentTriggerTypes } from './incidentTriggers';

export const triggerTypeIconPaths = {
  STATUS: '/static/images/script_steps/event-status-updates.svg',
  DELIVERYSTATUS: '/static/images/script_steps/device-delivery-updates.svg',
  RESPONSE: '/static/images/script_steps/notification-response.svg',
  SINGLERESPONSE:
    '/static/images/script_steps/notification-response-single.svg',
  ANNOTATION: '/static/images/script_steps/event-comments.svg',
  ESCALATION: '/static/images/script_steps/escalations.svg',
  TARGETEDRECIPIENTFAILURE:
    '/static/images/script_steps/targeted-recipient-failures.svg',
  EMAIL: '/static/images/script_steps/email-trigger.svg',
  LEGACY_WEBHOOK: 'icon-circle-arrow-right',
  FORM: IncidentInitiation,
  NOTIFY_TO_ENGAGE: NotifyToEngage,
  SEVERITY_CHANGE: SeverityChange,
  AUTOMATION: AutomationIcon,
  WORKFLOW: defaultCallableTriggerIconPath,
  // Not ideal but it's the easiest way to uncache the logo
  EBFD_INCIDENT_RESPONSE_TRIGGER: `${EVERBRIDGE_LOGO_PATH}?${Math.round(
    Date.now() / (1000 * 60),
  )}`,
  EBFD_INCIDENT_RESPONSE_SUB_TRIGGER: IconResponded,
};

export const triggerTypes = new Set([
  scriptStepTypes.BUILT_IN_HTTP,
  scriptStepTypes.CALLABLE_FLOW_RECEIVER,
  scriptStepTypes.CUSTOM_HTTP,
  scriptStepTypes.INBOUND_WEBHOOK,
  scriptStepTypes.OUTBOUND_WEBHOOK,
  scriptStepTypes.INBOUND_EMAIL,
  scriptStepTypes.FORM_TRIGGER,
  scriptStepTypes.AUTOMATION_TRIGGER,
  scriptStepTypes.INBOUND_EMAIL_UTILITIES,
  scriptStepTypes.EBFD_INCIDENT_RESPONSE_TRIGGER,
]);

export const EventTriggerType = {
  STATUS: 'STATUS',
  ANNOTATION: 'ANNOTATION',
  DELIVERYSTATUS: 'DELIVERYSTATUS',
  ESCALATION: 'ESCALATION',
  TARGETEDRECIPIENTFAILURE: 'TARGETEDRECIPIENTFAILURE',
  RESPONSE: 'RESPONSE',
  RESPONSEOPTION: 'RESPONSEOPTION',
};

export const AlertTriggerType = {
  STATUS: 'STATUS',
  ANNOTATION: 'ANNOTATION',
  DELIVERYSTATUS: 'DELIVERYSTATUS',
  ESCALATION: 'ESCALATION',
  TARGETEDRECIPIENTFAILURE: 'TARGETEDRECIPIENTFAILURE',
  RESPONSE: 'RESPONSE',
  RESPONSEOPTION: 'RESPONSEOPTION',
};

export const alertTriggerTypeValues = [
  AlertTriggerType.STATUS,
  AlertTriggerType.ANNOTATION,
  AlertTriggerType.DELIVERYSTATUS,
  AlertTriggerType.ESCALATION,
  AlertTriggerType.TARGETEDRECIPIENTFAILURE,
  AlertTriggerType.RESPONSE,
];

export const AlertTriggerTypeStringId = {
  [AlertTriggerType.STATUS]: 'ALERT_STATUS_UPDATES',
  [AlertTriggerType.ANNOTATION]: 'COMMENTS',
  [AlertTriggerType.DELIVERYSTATUS]: 'DEVICE_DELIVERY_UPDATES',
  [AlertTriggerType.ESCALATION]: 'ESCALATIONS',
  [AlertTriggerType.TARGETEDRECIPIENTFAILURE]: 'TARGETED_RECIPIENT_FAILURE',
  [AlertTriggerType.RESPONSE]: 'FLOW_DESIGN_RESPONSES',
};

export const IncidentTriggerTypeStringId = {
  ...IncidentTriggerTypes,
};
